import Cache from './catch'

export const CacheService = new Cache()